<template>
  <div class="news-item" v-if="isPublic && noEmptyCells">
    <p>
      <strong class="item-heading"
        >{{ formatIcon }} {{ localeDate }} | {{ trim(medium) }}
        <span v-show="hasPaywall">
          {{ paywallIcon }}</span
        ></strong
      >
      <br />
      <a class="item-title" :href="trim(link)">{{ trim(title) }}</a>
      <span class="lang-label" v-show="isForeign"> [{{ langLabel }}]</span>
    </p>
  </div>
</template>


<script>
export default {
  props: [
    "publish",
    "date",
    "medium",
    "format",
    "title",
    "link",
    "AW_AWCH",
    "paywall",
    "crosspost",
    "langLabel",
  ],
  data() {
    return {
      dateFormat: { month: "long", day: "numeric", year: "numeric" },
    };
  },
  computed: {
    today() {
      return new Date();
    },
    lastYear() {
      return this.today.getFullYear() - 1;
    },
    localeDate() {
      return this.date.toLocaleDateString(this.$language, this.dateFormat);
    },
    isLastTwoYears() {
      return this.date.getFullYear >= this.lastYear;
    },
    isForeign() {
      return this.langLabel != this.$language;
    },
    isPublic() {
      return this.publish == "Published" && this.crosspost == undefined;
    },
    isCH() {
      return this.AW_AWCH == "AWCH" || this.AW_AWCH == "AW & AWCH";
    },
    formatIcon() {
      if (
        this.format == "radio" ||
        this.format == "podcast" ||
        this.format == "audio"
      ) {
        return "🎧";
      }
      if (this.format == "video" || this.format == "tv feature") {
        return "📺";
      }
      if (this.format == "book chapter") {
        return "📖";
      } else return "📰";
    },
    hasPaywall() {
      if (this.paywall == "x") {
        return true;
      } else return false;
    },
    paywallIcon() {
      return "🔒";
    },
    noEmptyCells() {
      if (this.date == "Invalid Date") {
        console.log("No Date defined");
        return false;
      }
      if (this.medium == "") {
        console.log("No Medium defined");
        return false;
      }
      if (this.format == "") {
        console.log("No Category defined");
        return false;
      }
      if (this.title == "") {
        console.log("No Title defined");
        return false;
      }
      if (this.link == "") {
        console.log("No URL defined");
        return false;
      }
      if ( this.langLabel == "") {
        console.log("No Language defined");
        return false;
      } else return true;
    },
  },
  methods: {
    trim(str) {
      if (str != undefined) {
        return str.trim();
      }
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 12px;
}
.rest {
  font-size: 10px;
}
h3 {
  margin: 40px 0 0 !important;
}
ul {
  list-style-type: none !important;
  padding: 0 !important;
}
li {
  display: inline-block !important;
  margin: 0 10px !important;
}
a {
  color: #428bfa !important;
  text-decoration: none !important;
}
a:hover {
  text-decoration: underline !important;
}
.lang-label {
  font-family: "Courier New";
}
</style>